import { Dayjs } from "dayjs";

export interface RangePickersValues {
  startValue: Dayjs | null;
  endValue: Dayjs | null;
}

export enum PICKER_FIELD_MODE {
  date = "date",
  specificDate = "specific-date",
}

export interface SpecificDayValue {
  day: number | null;
  month: number | null;
  year: number | null;
  isWeekday?: boolean;
}

export enum SPECIFIC_DATE_PICKER_TAB {
  DAY = "day",
  MONTH = "month",
  YEAR = "year",
}

export interface SpecificDatePickerTabItem {
  label: string;
  value: number | string | null;
  key: SPECIFIC_DATE_PICKER_TAB;
}
